import { render } from "./ListadoAtencion.vue?vue&type=template&id=e55e3296"
import script from "./ListadoAtencion.vue?vue&type=script&lang=js"
export * from "./ListadoAtencion.vue?vue&type=script&lang=js"

import "./ListadoAtencion.vue?vue&type=style&index=0&id=e55e3296&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__